/** Traduction multilingue activée (sélecteur de langue + ressources locales). */
export const I18N_TRANSLATION_ENABLED = true;

export const I18N_DEFAULT_LANGUAGE = 'en' as const;
